import { oldKodeHit } from "@/lib/network";

// Label kecil "Dulu: KODE" hanya bila kata kunci cocok dengan kode lama (bukan kode/nama saat ini).
export function OldKodeLabel({ row, q, testid }) {
  const hit = oldKodeHit(row, q);
  if (!hit) return null;
  return <span className="ml-1 whitespace-nowrap rounded bg-[#FEF3C7] px-1 font-sans text-[10px] font-normal text-[#92400E]"
               data-testid={testid || `old-kode-${row.kode}`}>Dulu: {hit}</span>;
}
